<template>
  <v-card class="mx-auto mt-5" width="1000">
    <v-app-bar color="primary" dark>
      <v-toolbar-title> 友達一覧 </v-toolbar-title>
    </v-app-bar>
    <v-list subheader v-if="isLoginUser">
      <v-subheader class="font-weight-bold"> 友達承認待ちユーザー </v-subheader>
      <v-list-item v-if="friendApprovals.length === 0">
        <v-list-item-subtitle> 友達承認待ちユーザーはいません </v-list-item-subtitle>
      </v-list-item>
      <v-list-item v-else v-for="friendApproval in friendApprovals" :key="friendApproval.userId" @click="toUserPage(friendApproval)">
        <v-list-item-avatar>
          <v-img :src="friendApproval.userPhotoURL" />
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title v-text="friendApproval.userName" />
        </v-list-item-content>

        <v-list-item-content>
          <v-list-item-subtitle>
            <v-icon small> mdi-star-circle </v-icon>
            <span> {{ friendApproval.userAchievementPower }} </span>
          </v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-content>
          <v-list-item-subtitle v-text="friendApproval.userProfile" />
        </v-list-item-content>

        <v-list-item-action v-if="isLoginUser">
          <v-row>
            <v-tooltip bottom>
              <template v-slot:activator="{ attrs, on }">
                <v-btn color="primary" icon v-bind="attrs" v-on="on" @click="approve(friendApproval)">
                  <v-icon> mdi-account-check </v-icon>
                </v-btn>
              </template>
              <span> 承認する </span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ attrs, on }">
                <v-btn color="primary" icon v-bind="attrs" v-on="on" @click="reject(friendApproval)">
                  <v-icon> mdi-account-remove </v-icon>
                </v-btn>
              </template>
              <span> 拒否する </span>
            </v-tooltip>
          </v-row>
        </v-list-item-action>
      </v-list-item>
    </v-list>

    <v-divider v-if="isLoginUser" />

    <v-list subheader v-if="isLoginUser">
      <v-subheader class="font-weight-bold">友達申請中ユーザー</v-subheader>
      <v-list-item v-if="friendRequests.length === 0">
        <v-list-item-subtitle> 友達申請中ユーザーはいません</v-list-item-subtitle>
      </v-list-item>

      <v-list-item v-else v-for="friendRequest in friendRequests" :key="friendRequest.userId" @click="toUserPage(friendRequest.userId)">
        <v-list-item-avatar>
          <v-img :src="friendRequest.userPhotoURL" />
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title v-text="friendRequest.userName" />
        </v-list-item-content>

        <v-list-item-content>
          <v-list-item-subtitle>
            <v-icon small> mdi-star-circle </v-icon>
            <span> {{ friendRequest.userAchievementPower }} </span>
          </v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-content>
          <v-list-item-subtitle v-text="friendRequest.userProfile" />
        </v-list-item-content>

        <v-list-item-action v-if="isLoginUser">
          <v-tooltip bottom>
            <template v-slot:activator="{ attrs, on }">
              <v-btn color="primary" icon v-bind="attrs" v-on="on" @click="discontinue(friendRequest)">
                <v-icon> mdi-account-cancel </v-icon>
              </v-btn>
            </template>
            <span> 中止する </span>
          </v-tooltip>
        </v-list-item-action>
      </v-list-item>
    </v-list>

    <v-divider v-if="isLoginUser" />

    <v-list subheader>
      <v-subheader class="font-weight-bold"> 友達ユーザー</v-subheader>
      <v-list-item v-if="friends.length === 0">
        <v-list-item-subtitle> 友達ユーザーはいません</v-list-item-subtitle>
      </v-list-item>
      <v-list-item v-else v-for="friend in friends" :key="friend.userId" @click="toUserPage(friend.userId)" >
        <v-list-item-avatar>
          <v-img :src="friend.userPhotoURL" />
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title v-text="friend.userName" />
        </v-list-item-content>

        <v-list-item-content>
          <v-list-item-subtitle>
            <v-icon small> mdi-star-circle </v-icon>
            <span> {{ friend.userAchievementPower }} </span>
          </v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-content>
          <v-list-item-subtitle v-text="friend.userProfile" />
        </v-list-item-content>

        <v-list-item-action v-if="isLoginUser">
          <v-row>
            <v-tooltip bottom>
              <template v-slot:activator="{ attrs, on }">
                <v-btn color="primary" icon v-bind="attrs" v-on="on" @click="release(friend)">
                  <v-icon>mdi-account-minus</v-icon>
                </v-btn>
              </template>
              <span> 解除する </span>
            </v-tooltip>
          </v-row>
        </v-list-item-action>
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters([
      "loginUserId",
      "friend/loginUserFriends",
      "friend/otherUserFriends",
      "user/user"
    ]),
    // 友達
    friends() {
      const friends = [];
      const rawFriends = this.isLoginUser ? this["friend/loginUserFriends"] : this["friend/otherUserFriends"];
      rawFriends.forEach((friend) => {
        if (friend.friendStatus === 3) friends.push(friend);
      });
      return friends;
    },
    // 友達承認待ち
    friendApprovals() {
      const friendApprovals = [];
      const rawFriends = this.isLoginUser ? this["friend/loginUserFriends"] : this["friend/otherUserFriends"];
      rawFriends.forEach((friend) => {
        if (friend.friendStatus === 2) friendApprovals.push(friend);
      });
      return friendApprovals;
    },
    // 友達申請済み
    friendRequests() {
      const friendRequests = [];
      const rawFriends = this.isLoginUser ? this["friend/loginUserFriends"] : this["friend/otherUserFriends"];
      rawFriends.forEach((friend) => {
        if (friend.friendStatus === 1) friendRequests.push(friend);
      });
      return friendRequests;
    },
  },

  data: () => ({
    linkControl: true
  }),

  methods: {
    ...mapActions([
      "friend/approve",
      "friend/discontinue",
      "friend/reject",
      "friend/release"
    ]),
    // 友達申請を承認します.
    async approve(user) {
      this.linkControl = false;
      await this["friend/approve"](user);
      this.$emit("rerender");
    },
    // 友達申請を中止します.
    async discontinue(user) {
      this.linkControl = false;
      await this["friend/discontinue"](user);
      this.$emit("rerender");
    },
    // 友達申請を拒否します.
    async reject(user) {
      this.linkControl = false;
      await this["friend/reject"](user);
      this.$emit("rerender");
    },
    // 友達関係を解除します.
    async release(user) {
      this.linkControl = false;
      await this["friend/release"](user);
      this.$emit("rerender");
    },
    // ユーザーページに遷移します.
    toUserPage(userId) {
      if (this.linkControl === true) {
        this.$router.push({ name: "User", params: { "user_id": userId } });
      }
    },
  },

  props: {isLoginUser: Boolean}
};
</script>
